import { render, staticRenderFns } from "./PagamentosFiltros.vue?vue&type=template&id=0795f234"
import script from "./PagamentosFiltros.vue?vue&type=script&lang=js"
export * from "./PagamentosFiltros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports